export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    select: {
      minWidth: 150,
    },
    listSubHeader: {
      lineHeight: '2rem',
    },
  };
};
